export default __webpack_public_path__ + "static/media/greenLakeDemosbg.85a4b60f.jpg";